import { render, staticRenderFns } from "./FooterCmp.vue?vue&type=template&id=09284538&"
import script from "./FooterCmp.vue?vue&type=script&lang=js&"
export * from "./FooterCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports